export default __webpack_public_path__ + "static/media/checked_circle_filled.fadd4971.svg";